import $ from 'jquery';
// --- Section expand ---

// Training Page - Expanders
function initializeExpanders() {
  const $expanders = $('.section--training-sessions .expanders .expander-box');

  if ($expanders.length === 1) {
    const $singleBox = $expanders.first();
    const $expanderTitle = $singleBox.find('.expander-title');
    const $expanderContent = $singleBox.find('.expander-content');

    $singleBox.addClass('opened');
    $expanderTitle.attr('aria-expanded', 'true').attr('aria-pressed', 'true');
    $expanderContent.show();
  }

  $expanders.find('.expander-title').on('click keypress', function (e) {
    if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();

      const $title = $(this);
      const targetSelector = $title.data('filter');
      const $content = $(targetSelector);
      const $box = $title.closest('.expander-box');

      const isOpen = $box.hasClass('opened');

      $('.expander-box').removeClass('opened');
      $('.expander-title').attr('aria-expanded', 'false').attr('aria-pressed', 'false');
      $('.expander-content').slideUp();

      if (!isOpen) {
        $box.addClass('opened');
        $title.attr('aria-expanded', 'true').attr('aria-pressed', 'true');
        $content.slideDown();
      }
    }
  });

  //Open the 1st expander by default
  const $firstExpander = $(".expander-box").first();
	$firstExpander.addClass("opened");
	$firstExpander
		.find(".expander-title")
		.attr("aria-expanded", "true")
		.attr("aria-pressed", "true");
	$firstExpander.find(".expander-content").css("display", "block");

}
$(document).on('expanders:ready', function () {
  initializeExpanders();
});
// ----- // 

$('.expand-hidden').addClass('hidden')
$('.expand-hidden').slideUp(
  function(){
    $('.expand-hidden').removeClass('hidden')
  }
)
$('.expand-bottom .more2').click(function(){
  $('.expand-hidden').slideToggle()
  var t = $('.expand-bottom .more2').text() == 'Collapse' ? 'Expand to learn more' : 'Collapse'
  $('.expand-bottom .more2').text(t)
})



// --- Load more boxes (for sites with no filters) ---

$('.loadmore-list.collapsed').addClass('hidden')
$('.loadmore-list.collapsed').slideUp(
  function(){
    $('.loadmore-list.collapsed').removeClass('hidden')
  }
)

$('.loadmore-bottom .more2').click(function (){

  // Multiple loader using Masonry
  if ($(this).parents('.loadmore-multiple').length > 0) {
    $(this).parent().parent().find('.loadmore-list.collapsed').each(function(i){
      if (i > 5) {
        return false
      }
      $(this).removeClass('collapsed').show()
    })
    $('.grid').masonry()

  // Regular loader
  } else {
    $(this).parent().parent().find('.loadmore-list.collapsed').each(function(i){
      if (i > 0) {
        return false
      }
      $(this).removeClass('collapsed').slideDown()
    })
  }

  if ($(this).parent().parent().find('.loadmore-list.collapsed').length <= 0) {
    $(this).parent().parent().find('.loadmore-bottom').slideUp()
  } else {
    $(this).parent().parent().find('.loadmore-bottom').slideDown()
  }
})


// --- Expanders ---

function controlLocationCardsMobileDisplay() {
  if (window.innerWidth <= 480) {
    let cardsLength = 0;
    $('.archive-pages-location .expander-box').each(function() {
      $(this).find('.expander-content .row').each(function() {
        cardsLength = $(this).find('.col-md-4').length;
        $(this).find('.col-md-4').hide();
        $(this).find('.col-md-4:nth-child(-n+4)').show();      
        if (cardsLength > 3) {
          $(this).append('<div class="col show-more-locations">Show more</div>');
        }
      });
    });
  }
}

$(document).ready(function(){

  //Open all expanders which has the opened class
  $(".expanders .expander-box.opened .expander-content").slideDown();

  const toggleExpand = (e) => {
    const parentEle = $(e.currentTarget).parent();
    const expanderContentEle = parentEle.find('.expander-content');
    if(parentEle.hasClass('opened')) {
      parentEle.removeClass('opened');
      $(e.currentTarget).attr('aria-expanded', 'false');
      $(e.currentTarget).attr('aria-pressed', 'false');
      expanderContentEle.slideUp('slow');
    } else {
      parentEle.addClass('opened');
      expanderContentEle.slideDown('slow');
      $(e.currentTarget).attr('aria-expanded', 'true');
      $(e.currentTarget).attr('aria-pressed', 'true');
    }
  }

  const expanderTitle = $('.expander-title');

  expanderTitle.click(function(e){
    toggleExpand(e)
  });

  expanderTitle.keydown(function(e){
    let key = e.which;
    if(key === 13 || key === 32){
      toggleExpand(e)
    }
  });

  controlLocationCardsMobileDisplay();

  $('.archive-pages-location .expander-content .row .show-more-locations').on('click', function() {
    const parentEle = $(this).closest('.row');
    if (window.innerWidth <= 480) {
      var visibleCount = 0;
      parentEle.find('.col-md-4').each(function(){
        if ($(this).is(':hidden')) {
          if (visibleCount < 3) {
            $(this).show();
            visibleCount++;
          }        
        }
      });

      const hiddenCount = parentEle.find('.col-md-4:hidden').length;
      if (hiddenCount === 0) {
        $(this).remove();
      }
    }
  });
});

const arrows = document.querySelectorAll('.archive-arrow-collapse .collapse-arrow');
const socialNavs = document.querySelectorAll('.social-nav');

socialNavs.forEach(function(nav) {        
  const hasListItems = nav.querySelectorAll('li').length > 0;        
  const profileDetails = nav.closest('.profile-details'); 

  if (profileDetails) {
    const collapseArrowContainer = profileDetails.querySelector('.archive-arrow-collapse');       
    if (collapseArrowContainer && !hasListItems) {
      collapseArrowContainer.classList.add('hide-arrow');
    }
  }
});

arrows.forEach(arrow => {
  arrow.addEventListener('click', function () {
    const profileCard = this.closest('.profile-details');
    if (profileCard) {
      const socialNav = profileCard.querySelector('.social-nav');
      if (socialNav) {
        socialNav.classList.toggle('show');                   

        const arrowDown = profileCard.querySelector('.collapse-arrow.down');
        const arrowUp = profileCard.querySelector('.collapse-arrow.up');
        if (arrowDown && arrowUp) {
          if (socialNav.classList.contains('show')) {
            arrowDown.style.display = 'none';
            arrowUp.style.display = 'inline';
          } else {
            arrowDown.style.display = 'inline';
            arrowUp.style.display = 'none';
          }
        }
      }
    }
  });
});


// When only one location exists for a country, the accordion should remain open by default
$(document).ready(function () {
  const $expanderBoxes = $(".archive-pages-location .expander-box");

  if ($expanderBoxes.length === 1) {
      let $singleBox = $expanderBoxes.first();
      let $expanderTitle = $singleBox.find(".expander-title");
      let $expanderContent = $singleBox.find(".expander-content");

      $singleBox.addClass("opened");
      $expanderTitle.attr("aria-expanded", "true").attr("aria-pressed", "true");
      $expanderContent.css("display", "block");
  }
});